import { IAppState } from '../../redux';

export function selectIsVisibleViolationsExist(state: IAppState): boolean {
  return !state.visibleViolations.isValid;
}
